<template>
<div class="voice-filters-main-wrapper">
  <div class="voice-filters-first-row" ref="voiceFiltersFirstRow">
    <div class="group-filter-icon">
      <i class="fa fa-filter" aria-hidden="true" title="Filter by criteria"></i>
    </div>
    <!-- Voice Filter -->
    <div class="voice-filters-text-filter">
      <input placeholder="Filter by voice name or description"
        ref="voiceFilters.filter" type="text" :value="voiceFilters.filter"
        :class="['form-control voice-filter', {filled: voiceFilters.filter!=''}]"
        @keyup="filterChangeVoiceDescriptionDebounce('filter', $event)"
        @paste="filterChangeVoiceDescriptionDebounce('filter', $event)" ></input>
      <i class="ico ico-clear-filter btn-inside" aria-hidden="true"
        v-if="voiceFilters.filter!=''"
        @click="cleanFilterVal('voiceFilters.filter'); filterVoiceChange('filter');"></i>
    </div>

    <!-- Language Dropdown -->
    <MultiSelect v-if="mapVoiceFilterLanguages.length > 0"
      v-model="multiSelectVoiceModel.language"
      :selectionLimit="1" class="multi-select-language"
      :options="mapVoiceFilterLanguages" optionLabel="caption"
      data-captions="Languages" placeholder="Language"
      display="chip" :showToggleAll="false"
      @change="filterVoiceChange('language', $event)" />

    <!-- Accent Dropdown -->
    <MultiSelect v-if="lengthVoiceFilterAccents > 0"
      v-model="multiSelectVoiceModel.accent"
      class="multi-select-accent"
      :options="mapVoiceFilterAccents" optionLabel="caption"
      data-captions="Accents" placeholder="Accent"
      display="chip" :showToggleAll="false"
      filter
      @change="filterVoiceChange" />

    <!-- Native language Dropdown -->
    <MultiSelect v-if="mapVoiceFilterLanguages.length > 0"
      v-model="multiSelectVoiceModel.nativeLanguage"
      class="multi-select-native-lang"
      :options="mapVoiceFilterLanguages" optionLabel="caption"
      data-captions="Native languages" placeholder="Native language"
      display="chip" :showToggleAll="false"
      @change="filterVoiceChange" />

    <!-- Gender Dropdown -->
    <MultiSelect v-if="mapVoiceFilterLibraries.gender.length > 0"
      v-model="multiSelectVoiceModel.gender"
      :selectionLimit="1" class="multi-select-gender"
      :options="mapVoiceFilterLibraries.gender" optionLabel="caption"
      data-captions="Genders" placeholder="Gender"
      display="chip" :showToggleAll="false"
      @change="filterVoiceChange" />

    <!-- Age Dropdown -->
    <MultiSelect v-if="mapVoiceFilterLibraries.age.length > 0"
      v-model="multiSelectVoiceModel.age"
      class="multi-select-age"
      :options="mapVoiceFilterLibraries.age" optionLabel="caption"
      data-captions="Ages" placeholder="Age"
      display="chip" :showToggleAll="false"
      @change="filterVoiceChange" />

    <!-- HQ Dropdown -->
    <MultiSelect v-if="mapVoiceFilterHQ.length > 0"
      v-model="multiSelectVoiceModel.hq"
      :selectionLimit="1" class="multi-select-hq"
      :options="mapVoiceFilterHQ" optionLabel="caption"
      data-captions="HQ" placeholder="HQ"
      display="chip" :showToggleAll="false"
      @change="filterVoiceChange" />

    <!-- Notice Dropdown -->
    <MultiSelect v-if="mapVoiceFilterLibraries.notice.length > 0"
      v-model="multiSelectVoiceModel.notice"
      class="multi-select-notice"
      :options="mapVoiceFilterLibraries.notice" optionLabel="caption"
      data-captions="Notices" placeholder="Min. notice"
      display="chip" :showToggleAll="false"
      :selectionLimit="1"
      @change="filterVoiceChange" />
    <template v-for="(tagFilter, idx) in availableTagsFilters">
      <div :class="[{'-group-filter': idx === 0}]">
        <div v-if="idx === 0" class="group-filter-icon">
          <i class="fa fa-sort-amount-desc" aria-hidden="true" title="Sort by criteria"></i>
        </div>
        <MultiSelect v-if="mapVoiceFilterLibraries.tag[tagFilter.name] && mapVoiceFilterLibraries.tag[tagFilter.name].length > 0" 
          v-model="multiSelectVoiceModel.tag[tagFilter.name]"
          :class="['multi-select-' + tagFilter.key]"
          :options="mapVoiceFilterLibraries.tag[tagFilter.name]" optionLabel="caption"
          data-captions="Notices" :placeholder="tagFilter.label"
          display="chip" :showToggleAll="false"
          @change="filterVoiceChange" />
      </div>
    </template>
  </div>
  <!--<div class="voice-filters-first-row"-->
  <div class="voice-filters-second-row" ref="voiceFiltersSecondRow">
    <button class="btn btn-primary" :disabled="isVoicesListLoading" @click="generateCharacterApprove">Generate</button>
    <button class="btn btn-default" @click="cleanFilterVal('voiceFilters.filter'); resetFilters();">Reset filters</button>
    <button :disabled="!isReqFltrsSelected || isVoicesListLoading"
      class="btn btn-primary"
      @click="applyFilters">Filter</button>
  </div>
  <!--<div class="voice-filters-second-row"-->

</div>
<!--<div class="voice-filters-main-wrapper">-->
</template>

<script>

import _     from 'lodash';
import Vue   from 'vue';

import { mapGetters, mapActions } from 'vuex';
import { Languages } from "@src/mixins/lang_config.js"

import MultiSelect from 'primevue/multiselect';

export default {
    name: 'ElevenLabFiltersBar',
    props: {
      activeIndex: {
        type: Number,
        default: 0
      },
      onAddTab: {
        type: Function,
        default: function(){}
      },
      onApplyFilters: {
        type: Function,
        default: function(){}
      },
      character: {
        type: Object,
        default: null
      },
    },
    data() {
      return {
      };
    },
    watch: {},
    mounted() {},
    updated() {},
    methods: {
      filterVoiceChange (key, $event) {
        const newFilters = Object.entries(this.multiSelectVoiceModel).reduce((acc, [key, val])=>{
          if (Array.isArray(val)) {
            acc[key] = val.map((el)=>el.value);
          } else {
            acc[key] = Object.entries(val).reduce((_acc, [ _key, _val ]) => {
              _acc[_key] = _val.map((_el) => _el.value);
              return _acc;
            }, {});
          }
          return acc;
        }, {});
        if (key && key === 'filter') {
          newFilters.page = 0;
          newFilters.filter = $event ? $event.target.value : '';
        }
        if (key && key === 'language') {
          this.multiSelectVoiceModel.accent = [];
          newFilters.accent = [];
        }
        this.$store.commit('elevenLabsVoicesModule/set_voicesListEmpty');
        this.$store.commit('elevenLabsVoicesModule/set_FilterButtonPressed', false);
        this.$store.commit('elevenLabsVoicesFilters/set_voiceFilters', newFilters);
        this.$store.commit('elevenLabsVoicesModule/set_charactersListUpdateItem', {
          idx: this.activeIndex,
          uuid: this.character?.uuid,
          filters: newFilters,
          cleanVoice: true,
        });
        this.changeFilterVisual();
      },

      filterChangeVoiceDescriptionDebounce: _.debounce(function (key, $event) {
        this.filterVoiceChange(key, $event)
      }, 300),

      async applyFilters() {
        //await this.$store.dispatch('elevenLabsVoicesModule/applyFilterVoices', this.activeIndex);
        this.$emit('onApplyFilters', { index: this.activeIndex });
      },

      cleanFilterVal (key) {
        // To unlink chain between the input value and the model because of debounce
        if (this.$refs[key]) {
          this.$refs[key].value = '';
        }
      },

      resetFilters () {
        this.$emit('stop', {});
        this.$store.commit('elevenLabsVoicesFilters/set_resetVoiceFilters');
        this.$store.commit('elevenLabsVoicesModule/set_voicesListEmpty');
        this.$store.commit('elevenLabsVoicesModule/set_charactersListItemValue', {
          character: { uuid: this.character?.uuid },
          values: { voice: false, voice_id: false, filters: this.defaultVoiceFilters },
          idx: this.activeIndex
        });
        //this.$store.dispatch('elevenLabsVoicesModule/applyFilterVoices');
      },

      changeFilterVisual() {
        Vue.nextTick(()=>{
          const vFilters = this.$refs.voiceFiltersFirstRow.querySelectorAll('.p-multiselect-label-container .p-multiselect-label');
          for (const vContainer of vFilters) {
            const vTokens = vContainer.querySelectorAll('.p-multiselect-token');
            const maxTokens = 2;
            for (const [vIndex, vToken] of vTokens.entries()) {
              if (vIndex < maxTokens) {
                vToken.style.display = 'inline-block';
              } else {
                vToken.style.display = 'none';
              }
            }
            const moreCounterVal = vTokens.length - maxTokens;
            const moreCounterPrev = vContainer.querySelector('.p-multiselect-more-counter');
            if (moreCounterVal > 0) {
              if (moreCounterPrev) {
                moreCounterPrev.innerText = `+${moreCounterVal}`;
              } else {
                const counter = document.createElement('span');
                counter.className = 'p-multiselect-more-counter';
                counter.innerText = `+${moreCounterVal}`;
                vContainer.appendChild(counter);
              }
            } else {
              if (moreCounterPrev) {
                vContainer.removeChild(moreCounterPrev);
              }
            }
          }
        })
      },
      generateCharacterApprove() {
        if (!this.currentBookMeta.title) {
          return this.$modal.show('dialog', {
            title: 'Book Title required',
            text: 'Please specify Book Title to generate voice tags',
            buttons: [
              {
                title: 'Ok',
                handler: () => {
                  this.$modal.hide('dialog');
                },
                class: 'btn btn-primary'
              },
              
            ]
          });
        }
        this.$modal.show('dialog', {
          title: 'Generate voice tags',
          text: 'Generated voice tags are suggestions and may require review and adjustment.<br>Generate tags and filter voices?',
          buttons: [
            {
              title: 'Generate & Filter',
              handler: () => {
                this.$modal.hide('dialog');
                this.generateCharacter({bookid: this.currentBookid, characterIdx: this.activeIndex})
                  .then(() => {
                    this.$emit('onApplyFilters', { index: this.activeIndex });
                  });
              },
              class: 'btn btn-primary'
            },
            {
              title: 'Cancel',
              handler: () => {
                this.$modal.hide('dialog');
              },
              class: 'btn btn-default'
            }
          ]
        });
      },
      ...mapActions('elevenLabsVoicesModule', ['generateCharacter'])
    },
    computed: {
      ...mapGetters({
        voiceFilters:             'elevenLabsVoicesFilters/voiceFilters',
        multiSelectVoiceModel:    'elevenLabsVoicesFilters/multiSelectVoiceModel',
        mapVoiceFilterLanguages:  'elevenLabsVoicesFilters/mapVoiceFilterLanguages',
        mapVoiceFilterAccents:    'elevenLabsVoicesFilters/mapVoiceFilterAccents',
        lengthVoiceFilterAccents: 'elevenLabsVoicesFilters/lengthVoiceFilterAccents',
        mapVoiceFilterLibraries:  'elevenLabsVoicesFilters/mapVoiceFilterLibraries',
        mapVoiceFilterHQ:         'elevenLabsVoicesFilters/mapVoiceFilterHQ',
        isReqFltrsSelected:       'elevenLabsVoicesFilters/isReqFltrsSelected',
        defaultVoiceFilters:      'elevenLabsVoicesFilters/defaultVoiceFilters',
        availableTagsFilters:     'elevenLabsVoicesFilters/availableTagsFilters',
        currentBookid:            'currentBookid',
        currentBookMeta:          'currentBookMeta',
        isVoicesListLoading:      'elevenLabsVoicesModule/isVoicesListLoading'
      })
    },
    components: {
      MultiSelect
    },
    directives: {
    }
}
</script>

<style lang="less" scoped>

.voice-filters-main-wrapper {
  .voice-filters-first-row {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;

    .voice-filters-text-filter {
      width: 450px;
      margin-bottom: 10px;
      margin-right: 10px;

      input.form-control {
        display: inline;
        box-shadow: none;
        padding-top: 4px;
        padding-bottom: 4px;
        height: 32px;
      }

      input.form-control.voice-filter.filled {
        padding-right: 30px;
      }

      .btn-inside {
        margin-left: -26px;
        margin-top: 5px;
        z-index: 999;
        position: absolute;
      }
    }

    .p-component.p-multiselect {
      margin-bottom: 10px;
      margin-right: 10px;

      min-width: 14rem;
      border-radius: 4px;
      border: 1px solid #ccc;
      box-shadow: none;

      &.multi-select-language {
        min-width: 10rem;
      }
      &.multi-select-accent {

      }
      &.multi-select-gender {
        min-width: 10rem;
      }
      &.multi-select-age {
        min-width: 8rem;
      }
      &.multi-select-hq {
        min-width: 5rem;
      }
      &.multi-select-notice {
        min-width: 8rem;
      }
    }

    .or-divider {
      margin-bottom: 10px;
      margin-right: 10px;
      padding-top: 4px;
    }
  }

  .voice-filters-second-row {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: flex-end;

    button.btn {
      margin-left: 15px;
      &:first-child {
        margin-right: auto;
        margin-left: 0px;
      }
    }
  }
}
</style>

<style lang="less">
.voice-filters-main-wrapper {
  .voice-filters-first-row {
    .p-component.p-multiselect.p-multiselect-chip {
      .p-multiselect-token {
        border-radius: 4px;
        padding: 0.25rem 0.5rem;
        margin-right: 0.5rem;
        background: #edebe9;
        color: #323130;

        .p-multiselect-token-icon {
          margin-left: 2px;
          padding-top: 2px;
        }
      }
    }
  }
  .p-component.p-multiselect {
    .p-multiselect-label.p-placeholder {
      color: #888;
      /*padding: 0.25rem 0.5rem;*/
    }
    &.multi-select-language,
    &.multi-select-gender {
      .p-multiselect-label.p-placeholder {
        &:before {
          content: "*";
          color: red;
          vertical-align: middle;
          line-height: 1px;
        }
      }
    }
  }
  .group-filter-icon {
    min-width: 25px;
    i.fa {
      color: black;
      vertical-align: -webkit-baseline-middle;
    }
  }
  .-group-filter {
    display: flex;
    flex-wrap: nowrap;
    gap: 10px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/books/details/tts/11LabFiltersBar.vue